import { parseOrgConnectedAppsRates } from './useOrgConnectedAppsRates.ts';
import { useTapTrait } from './useTapTrait.ts';
import type { BannerTraitHookOptions, TapTraitResult } from './useTapTrait.ts';

/**
 * Keyed by `ProductKeys3P`, e.g. `drive:30,slack:72`. The CWR ghost icons rank on this
 * same trait, so both surfaces surface the same apps. Not `ORG_CONNECTED_APPS_RATE_TRAIT`,
 * which is Confluence-only and keyed by smartlink provider family.
 */
export const CONNECTOR_ORG_AUTH_RATE_TRAIT = 'rovo_connector_authed_users_percentage_by_app';

export type ConnectorOrgAuthRates = Record<string, number>;

export type UseConnectorOrgAuthRatesResult = TapTraitResult<ConnectorOrgAuthRates>;

export function useConnectorOrgAuthRates({
	skip,
}: BannerTraitHookOptions = {}): UseConnectorOrgAuthRatesResult {
	return useTapTrait(CONNECTOR_ORG_AUTH_RATE_TRAIT, parseOrgConnectedAppsRates, { skip });
}
